
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1NJu1", function(module, exports) {
const $bff07b8bbb17f66c$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $bff07b8bbb17f66c$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $bff07b8bbb17f66c$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $bff07b8bbb17f66c$export$71ff7382870ef1b0;

});

parcelRegister("ll379", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $jTNdj = parcelRequire("jTNdj");


var $cozmU = parcelRequire("cozmU");


var $1NVwf = parcelRequire("1NVwf");




const $7da53318f1fd530c$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(initialData !== undefined);
    const onMount = (0, $cozmU.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $cozmU.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};


const $0443f5c700dc203b$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $7da53318f1fd530c$export$317d52099614f316)(props);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                name: (0, $jTNdj.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $0443f5c700dc203b$export$b35129264a401b3c = /*#__PURE__*/ (0, $cozmU.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $cXtTj.default).checkGate('post_office_update_ufov2_placements');
    /**
   * If feature gate is not enabled, then we just return the children without the
   * UFO segments attached.
   */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $0443f5c700dc203b$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $0443f5c700dc203b$export$b35129264a401b3c;

});

parcelRegister("jTNdj", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $a1L5E = parcelRequire("a1L5E");

const $8f5948bf59d85fb8$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $b8pma.default),
    UFOSegment: (0, $a1L5E.default)
};
module.exports["UFOv2"] = $8f5948bf59d85fb8$export$c91b09caa8ecbab1;

});

parcelRegister("1NVwf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $2808315b9dcd7678$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $2808315b9dcd7678$export$21b400a8c8ebc91a;

});

parcelRegister("qzjr4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");





var $aHfj2 = parcelRequire("aHfj2");


var $cozmU = parcelRequire("cozmU");


var $9Nqm6 = parcelRequire("9Nqm6");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0688fdc237844f49$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $cozmU.useEffect)(()=>{
        if ($0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};








var $g8WS7 = parcelRequire("g8WS7");


var $jpjVJ = parcelRequire("jpjVJ");


var $kLVNa = parcelRequire("kLVNa");


var $lnqxO = parcelRequire("lnqxO");


var $lxTPJ = parcelRequire("lxTPJ");


var $6i8go = parcelRequire("6i8go");


var $kM1fo = parcelRequire("kM1fo");


var $jwHjP = parcelRequire("jwHjP");


var $9udEN = parcelRequire("9udEN");


var $gYVlH = parcelRequire("gYVlH");


var $f1G3w = parcelRequire("f1G3w");


var $1Pvvv = parcelRequire("1Pvvv");


var $3FUF4 = parcelRequire("3FUF4");


var $9JDIO = parcelRequire("9JDIO");


var $HUhul = parcelRequire("HUhul");


var $9NCOm = parcelRequire("9NCOm");



const $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "e9853d7654ed5b850897d305b090eb63b46035d1",
            b: "20690443",
            t: undefined
        }
    }
};
const $15ac6ff16ee48c24$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData,
        children: children
    });
};



var $6NRmI = parcelRequire("6NRmI");





var $bGVJw = parcelRequire("bGVJw");

var $1RMKR = parcelRequire("1RMKR");


var $1NJu1 = parcelRequire("1NJu1");

const $52edb35a97f45deb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $1RMKR.useStableObject)({
        ...(0, $1NJu1.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bGVJw.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};









var $4cICV = parcelRequire("4cICV");

const $9ea687c3ab35e390$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $1RMKR.useStableObject)(placement);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cICV.PlacementProvider), {
        value: stableValue,
        children: children
    });
};









var $5h1mk = parcelRequire("5h1mk");



const $0e2c91a22a84681f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $0e2c91a22a84681f$export$49fc3f3d8c7f99 = ()=>{
    return $0e2c91a22a84681f$var$isLocationAvailable() ? globalThis.location.href : undefined;
};


const $2e96bdbc145ab642$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $0e2c91a22a84681f$export$49fc3f3d8c7f99)();
    const stableRoute = (0, $1RMKR.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5h1mk.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};



var $ll379 = parcelRequire("ll379");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $cXtTj.default).checkGate($b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Nqm6.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $b95d67109e64283f$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $52edb35a97f45deb$export$d4982c0a28b18f63), {
        context: context,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9ea687c3ab35e390$export$e9fd288527498af6), {
            placement: placement,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2e96bdbc145ab642$export$ce13d00e696dfc96), {
                route: route,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $15ac6ff16ee48c24$export$5a66cdc9893b43e), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6NRmI.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0688fdc237844f49$export$2d84fd9af6c9e378), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $b95d67109e64283f$export$2b6596bcb1383a71;

});

parcelRegister("9Nqm6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $ffaea1b52a58fd24$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscription: undefined
});
const $ffaea1b52a58fd24$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ffaea1b52a58fd24$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $ffaea1b52a58fd24$export$1129f1fe63b2d7ab = ()=>{
    return (0, $cozmU.useContext)($ffaea1b52a58fd24$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $ffaea1b52a58fd24$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $ffaea1b52a58fd24$export$1129f1fe63b2d7ab;

});

parcelRegister("8BCsI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $852mP = parcelRequire("852mP");


var $aHfj2 = parcelRequire("aHfj2");


var $9EOlJ = parcelRequire("9EOlJ");

const $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $8aG6j.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7;

});

parcelRegister("l24yD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $fxKXz = parcelRequire("fxKXz");

const $9e3359973a0abf47$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxKXz.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withIntlProvider"] = $9e3359973a0abf47$export$a5d940130f33be3f;

});

parcelRegister("fxKXz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $aHfj2 = parcelRequire("aHfj2");


var $kSwu1 = parcelRequire("kSwu1");





var $fbwmZ = parcelRequire("fbwmZ");



var $89dc177a9d0388e1$exports = {};

$parcel$defineInteropFlag($89dc177a9d0388e1$exports);
$parcel$export($89dc177a9d0388e1$exports, "IntlMessageFormat", () => (parcelRequire("iaKxG")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $iaKxG = parcelRequire("iaKxG");



var $89dc177a9d0388e1$export$2e2bcd8739ae039 = (0, $iaKxG.IntlMessageFormat);



var $6qvYb = parcelRequire("6qvYb");




var $530d86f7aba8784a$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($530d86f7aba8784a$export$557d6acb76e8a244 || ($530d86f7aba8784a$export$557d6acb76e8a244 = {}));
var $530d86f7aba8784a$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $530d86f7aba8784a$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $530d86f7aba8784a$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($530d86f7aba8784a$export$c016d36112f6ddf8);
var $530d86f7aba8784a$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $530d86f7aba8784a$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($530d86f7aba8784a$export$c016d36112f6ddf8);
var $530d86f7aba8784a$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $530d86f7aba8784a$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($530d86f7aba8784a$export$c016d36112f6ddf8);
var $530d86f7aba8784a$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $530d86f7aba8784a$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($530d86f7aba8784a$export$c016d36112f6ddf8);
var $530d86f7aba8784a$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($530d86f7aba8784a$export$e3b7eee1dbc44895);
var $530d86f7aba8784a$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $530d86f7aba8784a$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($530d86f7aba8784a$export$c016d36112f6ddf8);


function $28a55df8f77ab30a$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $28a55df8f77ab30a$var$defaultErrorHandler = function(error) {};
var $28a55df8f77ab30a$var$defaultWarnHandler = function(warning) {};
var $28a55df8f77ab30a$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $28a55df8f77ab30a$var$defaultErrorHandler,
    onWarn: $28a55df8f77ab30a$var$defaultWarnHandler
};
function $28a55df8f77ab30a$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $28a55df8f77ab30a$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $28a55df8f77ab30a$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $28a55df8f77ab30a$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $6qvYb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $6qvYb.strategies).variadic
    });
    var getNumberFormat = (0, $6qvYb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.number),
        strategy: (0, $6qvYb.strategies).variadic
    });
    var getPluralRules = (0, $6qvYb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $6qvYb.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $6qvYb.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $iaKxG.IntlMessageFormat)(message, locales, overrideFormats, (0, $fbwmZ.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.message),
            strategy: (0, $6qvYb.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $6qvYb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $6qvYb.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $6qvYb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.list),
            strategy: (0, $6qvYb.strategies).variadic
        }),
        getDisplayNames: (0, $6qvYb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $28a55df8f77ab30a$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $6qvYb.strategies).variadic
        })
    };
}
function $28a55df8f77ab30a$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $530d86f7aba8784a$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


const $fccb8bc170dbb794$export$96a2a9656bab1d3d = 'post_office_suppress_missing_translation_errors';
const $fccb8bc170dbb794$export$d3da1ecaf1206c58 = (err)=>{
    if (err?.code === (0, $530d86f7aba8784a$export$557d6acb76e8a244).MISSING_TRANSLATION) return;
    return (0, $28a55df8f77ab30a$export$b52f8d6fc0d47415).onError(err);
};






var $cozmU = parcelRequire("cozmU");

const $0c7034cf70b43bde$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $cozmU.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};


const $6b21839eee678607$var$DOUBLE_WRAP_INTL_PROVIDER_GATE = 'post-office_enable_double-wrap-intl-provider';
function $6b21839eee678607$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $kSwu1.useIntl)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $6b21839eee678607$export$480518999dfc4151(props) {
    const { locale: locale } = $6b21839eee678607$var$useFetchLocale();
    const messages = (0, $0c7034cf70b43bde$export$2641ec9a2025a81f)(locale, props.messagesLoader, props.messages);
    const shouldDoubleWrapIntlProvider = (0, $cXtTj.default).checkGate($6b21839eee678607$var$DOUBLE_WRAP_INTL_PROVIDER_GATE);
    const shouldSuppressMissingTranslationErrors = (0, $cXtTj.default).checkGate((0, $fccb8bc170dbb794$export$96a2a9656bab1d3d));
    const suppressMissingTranslationErrorsProps = shouldSuppressMissingTranslationErrors ? {
        onError: (0, $fccb8bc170dbb794$export$d3da1ecaf1206c58)
    } : {};
    if (!shouldDoubleWrapIntlProvider) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        ...suppressMissingTranslationErrorsProps,
        children: props.children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        ...suppressMissingTranslationErrorsProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            ...suppressMissingTranslationErrorsProps,
            children: props.children
        })
    });
}
module.exports["IntlProvider"] = $6b21839eee678607$export$480518999dfc4151;

});

parcelRegister("o0RSX", function(module, exports) {
//#region src/index.ts

var $ddnoW = parcelRequire("ddnoW");

let $0482ea6551d2dfec$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $0482ea6551d2dfec$export$46f86d28cd0a5d38 = class extends Error {
};
var $0482ea6551d2dfec$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $0482ea6551d2dfec$export$66e065cfeb491a4d = class HydrationAbortError extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $0482ea6551d2dfec$export$69be53c018c89481 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6452976adc01572 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(cause, code){
        super($0482ea6551d2dfec$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $0482ea6551d2dfec$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $0482ea6551d2dfec$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $0482ea6551d2dfec$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $0482ea6551d2dfec$export$ed601cd0dc1a1be7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2833d4759f81601b = class extends $0482ea6551d2dfec$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8d39b103586e9fd4 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$f649da38897d27f7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2852c1c4d9aba3e = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4b7b4e09547e4bb3 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$360a094a97597d87 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4d068b43eb55165b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ac007ee150add337 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$19cb89dd679394cb = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$78651662ad470cc5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$43b3b4535703ed1b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8a5041670cdd8db2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1240ddc25cf964e6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3c4884b7ae7fe517 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$913b8e68dc7ae8fe = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3dfc27a8d3942f4d = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e5ccdf8bbfead7a2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$823733742d803ae6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1caa32527f23acd2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$a6f2aad8fa094b39 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2296e5dc6a1bf3d2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2f1e27130c2bf271 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d0dc094613469f2b = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5603eab37ce562f5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e0e9aa0e9c6b37ff = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3ad818f64601e141 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$25470bb6cba4fba0 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ce14d445679448b6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $0482ea6551d2dfec$export$c9a26a17db1045c8 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8ab4fb362168b928 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2afd69f57fe5285f = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$7635d2b1a281d626 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$9e1c6d00e675bc86 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError"), (0, $ddnoW._)(this, "recipient", void 0);
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6d1a4929f6ff1a32 = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$c504492f06c975b5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $0482ea6551d2dfec$export$1c932b9d1680ee0b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $0482ea6551d2dfec$export$85497ede72633b85 = class extends $0482ea6551d2dfec$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $0482ea6551d2dfec$export$359a331da49d1ec8 = class extends $0482ea6551d2dfec$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $0482ea6551d2dfec$export$8506e646874f88f6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $0482ea6551d2dfec$export$6a4077faeb1c609 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $0482ea6551d2dfec$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map
module.exports["PostOfficeErrorCodes"] = $0482ea6551d2dfec$export$b9722560029694e7;
module.exports["PostOfficeError"] = $0482ea6551d2dfec$export$d145ea5319863172;
module.exports["InvalidMessageTemplateIdError"] = $0482ea6551d2dfec$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0482ea6551d2dfec$export$3dfc27a8d3942f4d;

});

parcelRegister("b4B1V", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $38aadf7fa80db7e7$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $cozmU.createContext)($38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue);
const $38aadf7fa80db7e7$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $cozmU.useRef)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($38aadf7fa80db7e7$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $38aadf7fa80db7e7$export$bb426ba114b64992 = ()=>(0, $cozmU.useContext)($38aadf7fa80db7e7$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $38aadf7fa80db7e7$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $38aadf7fa80db7e7$export$bb426ba114b64992;

});

parcelRegister("d4rpM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");

const $2edd5268d1298569$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $2edd5268d1298569$export$8e6fb7035018b3e4;

});

parcelRegister("gKIF0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");





var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $7edc18d494c18e25$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $cozmU.useState)('pending');
    (0, $4mjUI.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated('allowed');
            return;
        }
        // Ref not set after template had a chance to run.
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: isHidden ? $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
};


const $721b9c50d6cef8f5$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7edc18d494c18e25$export$c8b5f992b8a1b38b), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
module.exports["MaybeTriggeredMessageValidator"] = $721b9c50d6cef8f5$export$dac988aa97dc7b79;

});

parcelRegister("bP5wt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");








var $4mjUI = parcelRequire("4mjUI");

const $522a2bdcd9585e84$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $cozmU.useRef)(onCleanup);
    (0, $4mjUI.useLayoutEffect)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};



var $7NHN3 = parcelRequire("7NHN3");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $5ae52cbfb074d546$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $cozmU.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    // Intentional empty deps: this effect must fire exactly once after the first commit.
    // The values captured here are the ones the caller passed at mount, which is the desired
    // "as of when the message was shown" semantic — if a caller subsequently passes a new
    // onShow or metadata, we should NOT fire again. Using non-empty deps would also cause
    // this effect to re-register on every render whenever a caller passes an unmemoized
    // `additionalMetadataFromFrontend={{ ... }}` literal, even though the body is a no-op
    // after first run. Strict-Mode double-invocation is still handled by hasShownRef.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $5ae52cbfb074d546$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const waitForTriggerCalledRef = (0, $cozmU.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $cozmU.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        const messageContentWithOptionalTeardown = onTeardown !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $522a2bdcd9585e84$export$ea970fe2c565070a), {
            onCleanup: onTeardown,
            children: messageContent
        }) : messageContent;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $wnnKE.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ae52cbfb074d546$var$OnChoreographerApproved, {
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContentWithOptionalTeardown
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $5ae52cbfb074d546$export$b5884e72fa051e28;

});

parcelRegister("wnnKE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $aHfj2 = parcelRequire("aHfj2");


var $cozmU = parcelRequire("cozmU");


var $6NRmI = parcelRequire("6NRmI");

const $4a16561cf48266ce$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $4a16561cf48266ce$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($4a16561cf48266ce$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $4a16561cf48266ce$export$8db7ba034addcd65;

});

parcelRegister("44R0O", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $18ac7c17ff477189$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $18ac7c17ff477189$export$9915b88f81e90e6e;

});

parcelRegister("j5DVd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");

var $f8158248d0f47600$export$1e511d4a378977f5;
var $f8158248d0f47600$export$6215040b989f9b0f;
var $f8158248d0f47600$export$436b63fa4855237f;
var $f8158248d0f47600$export$2e2bcd8739ae039;
var $f8158248d0f47600$export$95cef81be5ddcfd4;
"use strict";
$f8158248d0f47600$export$1e511d4a378977f5 = true;
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$export$95cef81be5ddcfd4 = void 0;

var $f8158248d0f47600$var$_handleViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("3Tfn6")));
$f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$var$_handleViewport.default;

var $f8158248d0f47600$var$_useInViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("byriw")));
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$var$_useInViewport.default;
function $f8158248d0f47600$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $f8158248d0f47600$var$customProps = $f8158248d0f47600$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $f8158248d0f47600$var$_default = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$var$_handleViewport.default;



var $b4B1V = parcelRequire("b4B1V");


var $1NVwf = parcelRequire("1NVwf");

const $08ec3000a15d9da6$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
const $08ec3000a15d9da6$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $cozmU.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $08ec3000a15d9da6$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $cozmU.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $f8158248d0f47600$export$6215040b989f9b0f)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $8aG6j.jsx)($08ec3000a15d9da6$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $08ec3000a15d9da6$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $08ec3000a15d9da6$export$14fe1fc3395b6e3f;

});

parcelRegister("baFbJ", function(module, exports) {

var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $4cICV = parcelRequire("4cICV");


var $kEPax = parcelRequire("kEPax");


var $cozmU = parcelRequire("cozmU");

class $4253c717b3565d29$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $4253c717b3565d29$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}




/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $dEG1b = parcelRequire("dEG1b");



var $984aeda379ad7f1a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});


const $858a4870c67919f0$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $kEPax.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $cozmU.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $4253c717b3565d29$export$44f397e2afeb89e0)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $4253c717b3565d29$export$44f397e2afeb89e0)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $4253c717b3565d29$export$44f397e2afeb89e0)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $cozmU.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $4253c717b3565d29$export$12bb62b204112f55)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $984aeda379ad7f1a$export$b31ffc6f7c85f1b).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $858a4870c67919f0$export$3cbbf1e81e2ecb39;

});

parcelRegister("3Tfn6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $2d526ea1e19243c2$export$1e511d4a378977f5, (v) => $2d526ea1e19243c2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2d526ea1e19243c2$export$2e2bcd8739ae039, (v) => $2d526ea1e19243c2$export$2e2bcd8739ae039 = v);
var $2d526ea1e19243c2$export$1e511d4a378977f5;
var $2d526ea1e19243c2$export$2e2bcd8739ae039;
"use strict";
$2d526ea1e19243c2$export$1e511d4a378977f5 = true;
$2d526ea1e19243c2$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $2d526ea1e19243c2$var$_hoistNonReactStatics = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("aH9xZ")));

var $2d526ea1e19243c2$var$_useInViewport = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("byriw")));

var $3dWch = parcelRequire("3dWch");


var $8aG6j = parcelRequire("8aG6j");

var $2d526ea1e19243c2$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $2d526ea1e19243c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d526ea1e19243c2$var$_extends() {
    return $2d526ea1e19243c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d526ea1e19243c2$var$_extends.apply(null, arguments);
}
function $2d526ea1e19243c2$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(TargetComponent, $2d526ea1e19243c2$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $3dWch.noop, onLeaveViewport: onLeaveViewport = $3dWch.noop } = _ref, restProps = $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(_ref, $2d526ea1e19243c2$var$_excluded);
        var node = (0, $cozmU.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $2d526ea1e19243c2$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $2d526ea1e19243c2$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ForwardedRefComponent, $2d526ea1e19243c2$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $2d526ea1e19243c2$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $2d526ea1e19243c2$var$_default = $2d526ea1e19243c2$export$2e2bcd8739ae039 = $2d526ea1e19243c2$var$handleViewport;

});

parcelRegister("byriw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $86980b6f9121fe40$export$1e511d4a378977f5, (v) => $86980b6f9121fe40$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86980b6f9121fe40$export$2e2bcd8739ae039, (v) => $86980b6f9121fe40$export$2e2bcd8739ae039 = v);
var $86980b6f9121fe40$export$1e511d4a378977f5;
var $86980b6f9121fe40$export$2e2bcd8739ae039;
"use strict";
$86980b6f9121fe40$export$1e511d4a378977f5 = true;
$86980b6f9121fe40$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $3dWch = parcelRequire("3dWch");

var $86980b6f9121fe40$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $86980b6f9121fe40$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    if (props === void 0) props = $3dWch.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $cozmU.useState)();
    var observer = (0, $cozmU.useRef)();
    var inViewportRef = (0, $cozmU.useRef)(false);
    var intersected = (0, $cozmU.useRef)(false);
    var enterCountRef = (0, $cozmU.useRef)(0);
    var leaveCountRef = (0, $cozmU.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $cozmU.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $cozmU.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $cozmU.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $86980b6f9121fe40$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $86980b6f9121fe40$var$_default = $86980b6f9121fe40$export$2e2bcd8739ae039 = $86980b6f9121fe40$var$useInViewport;

});

parcelRegister("jS1GQ", function(module, exports) {
const $6bdcc106a64db8f9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $6bdcc106a64db8f9$export$21c420c0c257c346;

});

parcelRegister("1dHYE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

const $c24c1359cebc9ade$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, children: children })=>{
    if (!enabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: children
    });
};
module.exports["MaybeChoreographerWrapper"] = $c24c1359cebc9ade$export$738797901aa9197a;

});

parcelRegister("aeEJA", function(module, exports) {

var $aHfj2 = parcelRequire("aHfj2");


var $j4yZr = parcelRequire("j4yZr");


var $cozmU = parcelRequire("cozmU");

const $b02ec9b1100b044c$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $b02ec9b1100b044c$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($b02ec9b1100b044c$export$18a0019e5439b209(res));
};
const $b02ec9b1100b044c$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $b02ec9b1100b044c$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $b02ec9b1100b044c$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });


class $d65c3221c86fee02$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $d65c3221c86fee02$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $cozmU.useState)((0, $b02ec9b1100b044c$export$f9a5bd0ffba29ffc)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $cozmU.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $b02ec9b1100b044c$export$b3732c8ff6f9c463)(res)) {
                const data = await res.json();
                setState((0, $b02ec9b1100b044c$export$24a6b176bdc41ce5)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $d65c3221c86fee02$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $b02ec9b1100b044c$export$cc3b967c039ed3e7)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $d65c3221c86fee02$export$8c5224d3af2f3c8b;
module.exports["useData"] = $d65c3221c86fee02$export$c1cf1cf4c5d51937;

});

parcelRegister("enlIM", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $bGVJw = parcelRequire("bGVJw");


var $gswTK = parcelRequire("gswTK");


var $4cICV = parcelRequire("4cICV");


var $dBFrb = parcelRequire("dBFrb");

const $37087aade39ee2a6$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $37087aade39ee2a6$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = (0, $dBFrb.buildSearchParams)(context);
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$37087aade39ee2a6$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};



var $cozmU = parcelRequire("cozmU");


var $aeEJA = parcelRequire("aeEJA");

const $1e4fc53796065581$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $cozmU.useRef)();
        const isRunningPromise = (0, $cozmU.useRef)(false);
        (0, $cozmU.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $cozmU.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $aeEJA.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $37087aade39ee2a6$export$ce743d02f83ee521)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $aeEJA.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};



var $iDSbf = parcelRequire("iDSbf");


var $aHfj2 = parcelRequire("aHfj2");


var $j4yZr = parcelRequire("j4yZr");

const $53956218589120b6$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $iDSbf.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};



var $9Nqm6 = parcelRequire("9Nqm6");




// https://switcheroo.atlassian.com/ui/gates/746a161c-d307-4db3-a966-8fe63c551fea/key/post-office_skip_rest_for_graphql_subscription
const $779dbc2874b7b8f6$var$SKIP_REST_FETCH_GATE = 'post-office_skip_rest_for_graphql_subscription';
const $779dbc2874b7b8f6$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const { subscription: subscription } = (0, $9Nqm6.useSubscriptionConfig)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found. Ensure this hook is used as a child of PlacementProvider.')
            });
        // Prefer the explicit prop when provided; fall back to the Switcheroo gate
        // so existing callers that have not yet migrated continue to work unchanged.
        const isClientFetch = config?.useClientFetch !== undefined ? config.useClientFetch : (0, $cXtTj.default).checkGate('post-office-use-placement-with-client');
        if (isClientFetch) return (0, $53956218589120b6$export$7a2a7b6f48ac7d1)(placementId, fetcher);
        return (0, $1e4fc53796065581$export$ee1d67e435d25cb5)(placementId, fetcher);
    }, [
        placementId,
        fetcher,
        config?.useClientFetch
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...queryParams,
        ...context
    };
    const apiDependencies = (0, $cozmU.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    // disable REST fetch for initialMessages for subscription based placements if the gate is enabled
    const isSubscriptionBasedFetchDisabled = subscription?.enabled === true && (0, $cXtTj.default).checkGate($779dbc2874b7b8f6$var$SKIP_REST_FETCH_GATE);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: isSubscriptionBasedFetchDisabled ? false : config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $779dbc2874b7b8f6$export$201bbce8187a6e3c;

});

parcelRegister("iaKxG", function(module, exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $fbwmZ = parcelRequire("fbwmZ");


var $6qvYb = parcelRequire("6qvYb");


var $55iKu = parcelRequire("55iKu");


var $iPU2z = parcelRequire("iPU2z");

// -- MessageFormat --------------------------------------------------------
function $d3ad43837a081fcc$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $d3ad43837a081fcc$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $d3ad43837a081fcc$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $fbwmZ.__assign)({}, defaultConfig));
}
function $d3ad43837a081fcc$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $d3ad43837a081fcc$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $6qvYb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3ad43837a081fcc$var$createFastMemoizeCache(cache.number),
            strategy: (0, $6qvYb.strategies).variadic
        }),
        getDateTimeFormat: (0, $6qvYb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3ad43837a081fcc$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $6qvYb.strategies).variadic
        }),
        getPluralRules: (0, $6qvYb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fbwmZ.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3ad43837a081fcc$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $6qvYb.strategies).variadic
        })
    };
}
var $d3ad43837a081fcc$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $iPU2z.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $iPU2z.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $fbwmZ.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $d3ad43837a081fcc$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $d3ad43837a081fcc$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $55iKu.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports["IntlMessageFormat"] = $d3ad43837a081fcc$export$d342343268debc40;

});

parcelRegister("73DnL", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $52375cb27685ac18$export$d4e71bc0b80dc0fb);

var $fbwmZ = parcelRequire("fbwmZ");

var $52375cb27685ac18$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($52375cb27685ac18$export$d4e71bc0b80dc0fb || ($52375cb27685ac18$export$d4e71bc0b80dc0fb = {}));
var $52375cb27685ac18$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $52375cb27685ac18$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $52375cb27685ac18$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($52375cb27685ac18$export$7369836851cc1329);
var $52375cb27685ac18$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $52375cb27685ac18$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($52375cb27685ac18$export$7369836851cc1329);
var $52375cb27685ac18$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $fbwmZ.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $52375cb27685ac18$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($52375cb27685ac18$export$7369836851cc1329);
module.exports["FormatError"] = $52375cb27685ac18$export$7369836851cc1329;
module.exports["InvalidValueError"] = $52375cb27685ac18$export$565c3afc07dfa382;
module.exports["InvalidValueTypeError"] = $52375cb27685ac18$export$cbc0db47c750f7c9;
module.exports["MissingValueError"] = $52375cb27685ac18$export$8bfc137e4d23fdf0;

});

parcelRegister("iPU2z", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $db6875dd44597133$export$49694c2877b44c57);
parcelRequire("55iKu");
var $iRoNt = parcelRequire("iRoNt");


var $73DnL = parcelRequire("73DnL");

var $db6875dd44597133$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($db6875dd44597133$export$49694c2877b44c57 || ($db6875dd44597133$export$49694c2877b44c57 = {}));
function $db6875dd44597133$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $db6875dd44597133$export$49694c2877b44c57.literal || part.type !== $db6875dd44597133$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $db6875dd44597133$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $db6875dd44597133$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $iRoNt.isLiteralElement)(els[0])) return [
        {
            type: $db6875dd44597133$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $iRoNt.isLiteralElement)(el)) {
            result.push({
                type: $db6875dd44597133$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $iRoNt.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $db6875dd44597133$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $73DnL.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $iRoNt.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $db6875dd44597133$export$49694c2877b44c57.literal : $db6875dd44597133$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $iRoNt.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $iRoNt.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $db6875dd44597133$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iRoNt.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $iRoNt.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $db6875dd44597133$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iRoNt.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $iRoNt.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $db6875dd44597133$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iRoNt.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$db6875dd44597133$export$df0c12a2d414a163(formatFn)) throw new (0, $73DnL.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $db6875dd44597133$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $db6875dd44597133$export$49694c2877b44c57.literal : $db6875dd44597133$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $iRoNt.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $73DnL.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $db6875dd44597133$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $iRoNt.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $73DnL.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $73DnL.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $73DnL.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $db6875dd44597133$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $db6875dd44597133$var$mergeLiteral(result);
}
module.exports["formatToParts"] = $db6875dd44597133$export$275d4a3bb5f66fda;

});

parcelRegister("4mjUI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
 * Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
 * contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
 *
 * Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
 *
 * See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */ const $c7f27652ce5a6cdc$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
module.exports["useLayoutEffect"] = $c7f27652ce5a6cdc$export$e5c5a5f917a5871c;

});

parcelRegister("3dWch", function(module, exports) {
$parcel$export(module.exports, "noop", () => $258fbab87dea3908$export$8793edee2d425525, (v) => $258fbab87dea3908$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $258fbab87dea3908$export$9c21a3269931e1e6, (v) => $258fbab87dea3908$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $258fbab87dea3908$export$ba43bf67f3d48107, (v) => $258fbab87dea3908$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $258fbab87dea3908$export$f84bd70098573c5c, (v) => $258fbab87dea3908$export$f84bd70098573c5c = v);
var $258fbab87dea3908$export$1e511d4a378977f5;
var $258fbab87dea3908$export$8793edee2d425525;
var $258fbab87dea3908$export$9c21a3269931e1e6;
var $258fbab87dea3908$export$ba43bf67f3d48107;
var $258fbab87dea3908$export$f84bd70098573c5c;
"use strict";
$258fbab87dea3908$export$1e511d4a378977f5 = true;
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$export$9c21a3269931e1e6 = $258fbab87dea3908$export$ba43bf67f3d48107 = $258fbab87dea3908$export$f84bd70098573c5c = void 0;
var $258fbab87dea3908$var$defaultOptions = $258fbab87dea3908$export$ba43bf67f3d48107 = {};
var $258fbab87dea3908$var$defaultConfig = $258fbab87dea3908$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $258fbab87dea3908$var$noop = ()=>{};
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$var$noop;
var $258fbab87dea3908$var$defaultProps = $258fbab87dea3908$export$9c21a3269931e1e6 = {
    onEnterViewport: $258fbab87dea3908$var$noop,
    onLeaveViewport: $258fbab87dea3908$var$noop
};

});

parcelRegister("6qvYb", function(module, exports) {
//
// Main
//
function $4addf84d50608f4f$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $4addf84d50608f4f$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $4addf84d50608f4f$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $4addf84d50608f4f$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $4addf84d50608f4f$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $4addf84d50608f4f$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $4addf84d50608f4f$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4addf84d50608f4f$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4addf84d50608f4f$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $4addf84d50608f4f$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $4addf84d50608f4f$var$monadic : $4addf84d50608f4f$var$variadic;
    return $4addf84d50608f4f$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $4addf84d50608f4f$var$strategyVariadic(fn, options) {
    return $4addf84d50608f4f$var$assemble(fn, this, $4addf84d50608f4f$var$variadic, options.cache.create(), options.serializer);
}
function $4addf84d50608f4f$var$strategyMonadic(fn, options) {
    return $4addf84d50608f4f$var$assemble(fn, this, $4addf84d50608f4f$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $4addf84d50608f4f$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $4addf84d50608f4f$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$4addf84d50608f4f$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$4addf84d50608f4f$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $4addf84d50608f4f$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $4addf84d50608f4f$var$ObjectWithoutPrototypeCache();
    }
};
var $4addf84d50608f4f$export$c5491a8691a23b9e = {
    variadic: $4addf84d50608f4f$var$strategyVariadic,
    monadic: $4addf84d50608f4f$var$strategyMonadic
}; //# sourceMappingURL=index.js.map
module.exports["memoize"] = $4addf84d50608f4f$export$fc10aeed3a532e2a;
module.exports["strategies"] = $4addf84d50608f4f$export$c5491a8691a23b9e;

});

parcelRegister("iRoNt", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $dbb06968393b1aff$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $dbb06968393b1aff$export$906452485466fa53);
var $dbb06968393b1aff$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($dbb06968393b1aff$export$b87f371cbc396fcf || ($dbb06968393b1aff$export$b87f371cbc396fcf = {}));
var $dbb06968393b1aff$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($dbb06968393b1aff$export$906452485466fa53 || ($dbb06968393b1aff$export$906452485466fa53 = {}));
function $dbb06968393b1aff$export$cfa10c5697238752(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.literal;
}
function $dbb06968393b1aff$export$4f55724281bdfaf9(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.argument;
}
function $dbb06968393b1aff$export$e11187b219e191e1(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.number;
}
function $dbb06968393b1aff$export$32d811605da75f40(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.date;
}
function $dbb06968393b1aff$export$34ec46f596b1702f(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.time;
}
function $dbb06968393b1aff$export$dcfe1c11d168b5a1(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.select;
}
function $dbb06968393b1aff$export$6c796d116f0a4fbc(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.plural;
}
function $dbb06968393b1aff$export$c0ece297bdd0c082(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.pound;
}
function $dbb06968393b1aff$export$5c83de34745812b(el) {
    return el.type === $dbb06968393b1aff$export$b87f371cbc396fcf.tag;
}
function $dbb06968393b1aff$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $dbb06968393b1aff$export$906452485466fa53.number);
}
function $dbb06968393b1aff$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $dbb06968393b1aff$export$906452485466fa53.dateTime);
}
function $dbb06968393b1aff$export$f0ac572c1121c662(value) {
    return {
        type: $dbb06968393b1aff$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $dbb06968393b1aff$export$425e864b0ba114f1(value, style) {
    return {
        type: $dbb06968393b1aff$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}
module.exports["isLiteralElement"] = $dbb06968393b1aff$export$cfa10c5697238752;
module.exports["isArgumentElement"] = $dbb06968393b1aff$export$4f55724281bdfaf9;
module.exports["isNumberElement"] = $dbb06968393b1aff$export$e11187b219e191e1;
module.exports["isDateElement"] = $dbb06968393b1aff$export$32d811605da75f40;
module.exports["isTimeElement"] = $dbb06968393b1aff$export$34ec46f596b1702f;
module.exports["isSelectElement"] = $dbb06968393b1aff$export$dcfe1c11d168b5a1;
module.exports["isPluralElement"] = $dbb06968393b1aff$export$6c796d116f0a4fbc;
module.exports["isPoundElement"] = $dbb06968393b1aff$export$c0ece297bdd0c082;
module.exports["isTagElement"] = $dbb06968393b1aff$export$5c83de34745812b;
module.exports["isNumberSkeleton"] = $dbb06968393b1aff$export$3f9a19cd4152eda3;
module.exports["isDateTimeSkeleton"] = $dbb06968393b1aff$export$7680c41f1a55f4cf;

});

parcelRegister("fP9vC", function(module, exports) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $b852feb50f75ee63$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $b852feb50f75ee63$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($b852feb50f75ee63$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}
module.exports["parseDateTimeSkeleton"] = $b852feb50f75ee63$export$f7b99fb377fe69fa;

});

parcelRegister("1NfAi", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

// @generated from regex-gen.ts
var $2c3708e640952c77$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $14e674c83bb7d97b$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $2c3708e640952c77$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $14e674c83bb7d97b$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $14e674c83bb7d97b$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $14e674c83bb7d97b$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $14e674c83bb7d97b$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $14e674c83bb7d97b$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $14e674c83bb7d97b$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($14e674c83bb7d97b$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $14e674c83bb7d97b$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $14e674c83bb7d97b$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$14e674c83bb7d97b$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $14e674c83bb7d97b$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $14e674c83bb7d97b$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $14e674c83bb7d97b$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $14e674c83bb7d97b$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, all), $14e674c83bb7d97b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, all), $14e674c83bb7d97b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($14e674c83bb7d97b$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($14e674c83bb7d97b$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($14e674c83bb7d97b$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($14e674c83bb7d97b$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), $14e674c83bb7d97b$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($14e674c83bb7d97b$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), $14e674c83bb7d97b$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $14e674c83bb7d97b$var$parseSign(token.stem);
        if (signOpts) result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $14e674c83bb7d97b$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports["parseNumberSkeletonFromString"] = $14e674c83bb7d97b$export$71cee2f16fba2480;
module.exports["parseNumberSkeleton"] = $14e674c83bb7d97b$export$47c6f8480bda3e11;

});

parcelRegister("55iKu", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("iRoNt")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("iRoNt")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("iRoNt")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("iRoNt")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("iRoNt")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("iRoNt")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("iRoNt")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("iRoNt")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("iRoNt")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("iRoNt")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("iRoNt")).isTimeElement);
$parcel$export(module.exports, "parse", () => $3b3bf68615a0c4b9$export$98e6a39c04603d36);

var $fbwmZ = parcelRequire("fbwmZ");


var $b9gRN = parcelRequire("b9gRN");


var $jzNV3 = parcelRequire("jzNV3");


var $iRoNt = parcelRequire("iRoNt");

function $3b3bf68615a0c4b9$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $iRoNt.isSelectElement)(el) || (0, $iRoNt.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $3b3bf68615a0c4b9$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $iRoNt.isNumberElement)(el) && (0, $iRoNt.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $iRoNt.isDateElement)(el) || (0, $iRoNt.isTimeElement)(el)) && (0, $iRoNt.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $iRoNt.isTagElement)(el)) $3b3bf68615a0c4b9$var$pruneLocation(el.children);
    });
}
function $3b3bf68615a0c4b9$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $fbwmZ.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $jzNV3.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $b9gRN.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $3b3bf68615a0c4b9$var$pruneLocation(result.val);
    return result.val;
}
var $3b3bf68615a0c4b9$export$d3c1bfa0f7d806e9 = (0, $jzNV3.Parser);

});

parcelRegister("b9gRN", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $81dd9e535e15bc15$export$896afd8541959ee5);
var $81dd9e535e15bc15$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($81dd9e535e15bc15$export$896afd8541959ee5 || ($81dd9e535e15bc15$export$896afd8541959ee5 = {}));

});

parcelRegister("jzNV3", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $b9gRN = parcelRequire("b9gRN");


var $iRoNt = parcelRequire("iRoNt");


var $d3z1o = parcelRequire("d3z1o");

parcelRequire("lvjFe");
var $fP9vC = parcelRequire("fP9vC");
var $1NfAi = parcelRequire("1NfAi");


var $gvUi5 = parcelRequire("gvUi5");

var $e4080225946afe44$var$_a;
var $e4080225946afe44$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $d3z1o.SPACE_SEPARATOR_REGEX).source, "*"));
var $e4080225946afe44$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $d3z1o.SPACE_SEPARATOR_REGEX).source, "*$"));
function $e4080225946afe44$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $e4080225946afe44$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $e4080225946afe44$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $e4080225946afe44$var$hasNativeFromEntries = !!Object.fromEntries;
var $e4080225946afe44$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $e4080225946afe44$var$hasTrimStart = !!String.prototype.trimStart;
var $e4080225946afe44$var$hasTrimEnd = !!String.prototype.trimEnd;
var $e4080225946afe44$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $e4080225946afe44$var$isSafeInteger = $e4080225946afe44$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $e4080225946afe44$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $e4080225946afe44$var$re = $e4080225946afe44$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $e4080225946afe44$var$REGEX_SUPPORTS_U_AND_Y = (($e4080225946afe44$var$_a = $e4080225946afe44$var$re.exec('a')) === null || $e4080225946afe44$var$_a === void 0 ? void 0 : $e4080225946afe44$var$_a[0]) === 'a';
} catch (_) {
    $e4080225946afe44$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $e4080225946afe44$var$startsWith = $e4080225946afe44$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $e4080225946afe44$var$fromCodePoint = $e4080225946afe44$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $e4080225946afe44$var$fromEntries = // native
$e4080225946afe44$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $e4080225946afe44$var$codePointAt = $e4080225946afe44$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $e4080225946afe44$var$trimStart = $e4080225946afe44$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($e4080225946afe44$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $e4080225946afe44$var$trimEnd = $e4080225946afe44$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($e4080225946afe44$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $e4080225946afe44$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $e4080225946afe44$var$matchIdentifierAtIndex;
if ($e4080225946afe44$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $e4080225946afe44$var$IDENTIFIER_PREFIX_RE_1 = $e4080225946afe44$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $e4080225946afe44$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $e4080225946afe44$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $e4080225946afe44$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$e4080225946afe44$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $e4080225946afe44$var$codePointAt(s, index);
        if (c === undefined || $e4080225946afe44$var$_isWhiteSpace(c) || $e4080225946afe44$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $e4080225946afe44$var$fromCodePoint.apply(void 0, match);
};
var $e4080225946afe44$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $iRoNt.TYPE).pound,
                    location: $e4080225946afe44$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $b9gRN.ErrorKind).UNMATCHED_CLOSING_TAG, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $e4080225946afe44$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $iRoNt.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $e4080225946afe44$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$e4080225946afe44$var$_isAlpha(this.char())) return this.error((0, $b9gRN.ErrorKind).INVALID_TAG, $e4080225946afe44$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $b9gRN.ErrorKind).UNMATCHED_CLOSING_TAG, $e4080225946afe44$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $b9gRN.ErrorKind).INVALID_TAG, $e4080225946afe44$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $iRoNt.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $e4080225946afe44$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $b9gRN.ErrorKind).UNCLOSED_TAG, $e4080225946afe44$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $b9gRN.ErrorKind).INVALID_TAG, $e4080225946afe44$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $e4080225946afe44$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $e4080225946afe44$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $iRoNt.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$e4080225946afe44$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $e4080225946afe44$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $e4080225946afe44$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $b9gRN.ErrorKind).EMPTY_ARGUMENT, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $b9gRN.ErrorKind).MALFORMED_ARGUMENT, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $iRoNt.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $b9gRN.ErrorKind).MALFORMED_ARGUMENT, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $e4080225946afe44$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $e4080225946afe44$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_TYPE, $e4080225946afe44$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $e4080225946afe44$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_STYLE, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $e4080225946afe44$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $e4080225946afe44$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $e4080225946afe44$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $iRoNt.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $b9gRN.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $gvUi5.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $iRoNt.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $fP9vC.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $iRoNt.TYPE).date : (0, $iRoNt.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $iRoNt.TYPE).number : argType === 'date' ? (0, $iRoNt.TYPE).date : (0, $iRoNt.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $b9gRN.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $e4080225946afe44$var$createLocation(typeEndPosition_1, (0, $fbwmZ.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $b9gRN.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $b9gRN.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $b9gRN.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $iRoNt.TYPE).select,
                        value: value,
                        options: $e4080225946afe44$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $iRoNt.TYPE).plural,
                        value: value,
                        options: $e4080225946afe44$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $b9gRN.ErrorKind).INVALID_ARGUMENT_TYPE, $e4080225946afe44$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $b9gRN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $b9gRN.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $e4080225946afe44$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $1NfAi.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $b9gRN.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $iRoNt.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $1NfAi.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $b9gRN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $b9gRN.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $e4080225946afe44$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $b9gRN.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $b9gRN.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $b9gRN.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $b9gRN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $e4080225946afe44$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $b9gRN.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $b9gRN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $b9gRN.ErrorKind).MISSING_OTHER_CLAUSE, $e4080225946afe44$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $e4080225946afe44$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$e4080225946afe44$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $e4080225946afe44$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($e4080225946afe44$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $e4080225946afe44$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $e4080225946afe44$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $e4080225946afe44$var$_isAlphaOrSlash(codepoint) {
    return $e4080225946afe44$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $e4080225946afe44$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $e4080225946afe44$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $e4080225946afe44$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}
module.exports["Parser"] = $e4080225946afe44$export$7acfa6ed01010e37;

});

parcelRegister("d3z1o", function(module, exports) {
// @generated from regex-gen.ts
var $9816b8b05167abc4$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $9816b8b05167abc4$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;
module.exports["SPACE_SEPARATOR_REGEX"] = $9816b8b05167abc4$export$523451f94304dd6c;

});

parcelRegister("lvjFe", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("fP9vC")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("1NfAi")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("1NfAi")).parseNumberSkeletonFromString);
parcelRequire("fP9vC");

parcelRequire("1NfAi");


});

parcelRegister("gvUi5", function(module, exports) {

var $10Epp = parcelRequire("10Epp");

function $c05b34c4dcc5cee3$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $c05b34c4dcc5cee3$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $c05b34c4dcc5cee3$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $10Epp.timeData)[regionTag || ''] || (0, $10Epp.timeData)[languageTag || ''] || (0, $10Epp.timeData)["".concat(languageTag, "-001")] || (0, $10Epp.timeData)['001'];
    return hourCycles[0];
}
module.exports["getBestPattern"] = $c05b34c4dcc5cee3$export$29c5368be8904d27;

});

parcelRegister("10Epp", function(module, exports) {
// @generated from time-data-gen.ts
// prettier-ignore  
var $0bc522e88ae8f67c$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};
module.exports["timeData"] = $0bc522e88ae8f67c$export$a8c9209db4084317;

});


$parcel$global.rlb("jCSah")
//# sourceMappingURL=ShareAndRestrictDialog.5ddadb79.js.map
